import React, { Component } from "react";
import {Modal, Input, Form, Button} from "antd";
import axios from "../../../../services/axios";
import Axios from "axios";
import {errorMessage} from "../../../Utils";

const FormItem = Form.Item;
const { TextArea } = Input;

class ModalValidationSPK extends Component {
    constructor(props) {
        super(props);
        this.state = {
            confirmLoading: false,
            spkNotes: null,
            isApproved: false
        };
    }

    handleSubmit = async (type) => {
        const {spkNotes} = this.state
        const {id, actionModal} = this.props
        this.setState({ isLoading: true });
        await axios.patch(`/car-sales/${id}/spk-approval`, {spkNotes, isApproved: type === "approve"})
            .then(result => {
                // message.success(`Berhasil reject approval`);
                actionModal()
                // this.props.history.push(`/home/e-approval/selling-system`);
            })
            .catch(err => {
                if (!Axios.isCancel(err)) {
                    errorMessage(err.response || err);
                    this.setState({ isLoading: false });
                }
            });
        this.setState({ isLoading: false });
    }

    render() {
        const { confirmLoading } = this.state;
        const { toggleShowModal, showModal } = this.props;
        return (
            <Modal
                title="Validasi SPK"
                visible={showModal}
                confirmLoading={confirmLoading}
                okText={"Simpan"}
                onOk={() => this.handleSubmit("approve")}
                onCancel={() => toggleShowModal(false)}
                footer={[
                    <Button key="back" onClick={() => toggleShowModal(false)}>
                        Back
                    </Button>,
                    <Button key="button" type="danger" loading={confirmLoading} onClick={() => this.handleSubmit("reject")}>
                        Reject
                    </Button>,
                    <Button key="button" type="primary" loading={confirmLoading} onClick={() => this.handleSubmit("approve")}>
                        Approve
                    </Button>,
                ]}
                width={450}>
                <p>Masukkan alasan anda pada approval ini</p>
                <p style={{margin: 0}}>Alasan</p>
                <TextArea rows={4} placeholder={"Masukkan alasan anda"} onChange={(event) => this.setState({spkNotes: event.target.value})} />
            </Modal>
        );
    }
}

export default ModalValidationSPK;



// WEBPACK FOOTER //
// src/components/Dashboard/EApproval/Modal/ModalValidationSPK.js